<template>
    <section style="width: 100%; height: 100%;">
        <b-overlay :show="loading" rounded="sm">
            <chart :options="chartOptions" ref="chart" style="width: 100%; height: 100%;"></chart>
            <div>
                <label><small>Proveedores:</small></label>
                <Multiselect
                    multiple
                    label="name"
                    track-by="name"
                    :options="optsSelect"
                    v-model="selectedCategory"
                    @select="filterByCategory"
                    @remove="filterByCategory"
                    group-label="group"
                    group-values="options"
                    group-select
                />
            </div>    
            <span>Total de rides:{{totalRides}}</span>
        </b-overlay>
    </section>
</template>

<script>
    import {Chart} from 'highcharts-vue'
    import api from '../../../../../api.js'
    import Highcharts from 'highcharts'
    import exportingInit from 'highcharts/modules/exporting'
    exportingInit(Highcharts)
    import Multiselect from 'vue-multiselect';
    export default {
        name: "AveragePerSupplierByAirport",
        components:{Chart,Multiselect},
        props: {
            filters: {
                type : Object,
                required: true
            },
            triggerSearch:{
                type : Number,
                required: true
            }
        },
        data(){
            let seriesExample = [{
                name:"",
                data:[]
            }];

            return {
                selectedCategory:[],
                originalSeries:[],
                totalRides:0,
                loading:false,
                exporting: {
                    enabled: true
                },
                codeReport : "average-reviews-suppliers-airport",
                chartOptions:{
                    title: {
                        text: 'Conversion de reviews por Proveedor-Aeropuerto'
                    },
                    tooltip: {
                        formatter: function(tooltip) {
                            let original = tooltip.defaultFormatter.call(this, tooltip);
                            let detalle   = this.point.details??{};
                            for (let status in detalle ){
                                original.push(status+"= <b>"+detalle[status]+"</b><br/>");
                            }
                            return original;
                        }
                    },
                    yAxis: {
                        title: {
                            text: ''
                        }
                    },
                    exporting:{
                        buttons:{
                            menuItems:["viewFullscreen"]
                        }
                    },
                    chart:{
                        type:'pie'
                    },
                    series: seriesExample,
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: true,
                                //format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                            }
                        }
                    },
                    
                }
            }
        },
        computed:{
            optsSelect(){
                if(this.$root.isEmpty(this.originalSeries.data)) return [];
                return [
					{
						group: "SELECT ALL",
						options: this.originalSeries.data
					}
				];
            },
        },
        methods:{
            fetchDataChart(){
                this.selectedCategory=[]
                this.loading=true;
                api(this).get(`/dashboard/operations/charts/${this.codeReport}`,{params: {filters:this.filters}}).then((res) => {
                    this.totalRides                        = res.data.totalRides;
                    this.originalSeries                    = {...res.data.series};
                    this.chartOptions.series               = res.data.series;
                    if(this.$refs.chart.chart){
                        this.$refs.chart.chart.reflow()
                    }
                }).catch(this.$root.handleRequestError).finally(()=>{
                    this.loading=false;
                    this.$emit('finished');
                })
                
            },
           
            filterByCategory() {
                let originalSeriesLocal = this.chartOptions.series;
                setTimeout(() => {
                    if (this.selectedCategory.length>0) {
                        let selectedCategoriesIDS = this.selectedCategory.map((item)=>item.name)
                        // Filter series based on the selected category
                        const filteredSeries = this.originalSeries.data.filter(series => selectedCategoriesIDS.includes(series.name));
                        this.chartOptions.series.data = filteredSeries;
                        
                    } else {
                        const filteredSeries = [...originalSeriesLocal.data]
                        // Show all series when "Show All Categories" is selected
                        this.chartOptions.series.data =[{ name: 'Filtered Series', data: filteredSeries }];
                    }
                    // Redraw the chart after updating the series
                    //console.log(this.chartOptions.series)
                    this.$refs.chart.chart.update({
                        series: []
                    });
                }, 0);
            },
             
        },
        watch:{
            triggerSearch(){//este valor es reactivo, el padre decide en que momento se dispara la busqueda
                this.fetchDataChart();
               
            }
        },
        mounted() {
            if(this.triggerSearch>0){
                this.fetchDataChart();
            }
        }
    }
</script>

<style scoped>

</style>